<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
  <div class="schedule-con">
    <iframe :src="wlInfo.map_express" frameborder="0" class="ifr"></iframe>
    <img src="" class="schedule-con__wlimg" />
    <div class="flex schedule-con-info">
      <div class="flex wlinfo">
        <img :src="wlInfo.store.head_pic" :onerror="Imgerror" />
        <p>{{ wlInfo.store.store_name }}</p>
      </div>
      <div class="flex between center wlinfo-btn-box">
        <!-- <input type="hidden" id="myInput" :value="wlInfo.invoice_no" /> -->
        <p>{{ wlInfo.shipping_name }}: <span class="c999999">{{ wlInfo.invoice_no }}</span></p>
        <div class="flex center wlinfo-btn">
          <button @click="copy">复制</button>
          <span></span>
          <p @click="handleTel" v-if="wlInfo.moblie">打电话</p>
        </div>
      </div>
      <p class="wlinfo-address size14">
        收货地址: <span class="c999999">{{ wlInfo.address }}</span>
      </p>
    </div>
  </div>
  <div class="graybar"></div>
  <div class="step">
    <div
      v-for="(item, index) in wlInfo.express"
      :key="index"
      class="step__item"
    >
      <div class="step__txt">
        <div style="position: relative">
          <p class="step__txt__tle">{{ item.time }}</p>
          <div class="step__circle"></div>
        </div>
        <div class="step__txt__desc">
          {{ item.context }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import useClipboard from 'vue-clipboard3'
import { ref } from "vue";
import ajax from "@/utils/request.js";
import {showToast} from "vant";
import {useRoute} from "vue-router";

const {query} = useRoute();

// const props = defineProps({
//     order_id: {
//         type: Number
//     }
// })

// const active = ref(1);
// const list = [
//   {
//     txt: "2023-02-04 08:23",
//   },
//   {
//     txt: "2023-02-04 08:23",
//   },
//   {
//     txt: "2023-02-04 08:23",
//   },
//   {
//     txt: "2023-02-04 08:23",
//   },
//   {
//     txt: "2023-02-04 08:23",
//   },
// ];
const copy = async () => {
  const { toClipboard } = useClipboard()
            
  try {
      await toClipboard(wlInfo.value.invoice_no)
      showToast("复制订单号成功")
    } catch (e) {
      showToast("当前浏览器版本不支持复制，请长按复制")
  }
  // var copyText = document.getElementById("myInput");
  // copyText.select();
  // navigator.clipboard.writeText(copyText.value);
  // showToast("复制成功");
};
// const isActive = (index) => {
//   return active.value === index;
// };
const handleTel = () => {
  window.location.href = "tel://"+wlInfo.value.moblie;
};

//获取物流信息
const wlInfo = ref({})
ajax.post("order/getlogistics",{id: query.id,typeid: query.typeid}).then(res => {
    console.log(res.data)
    wlInfo.value = res.data
})
</script>
<style scoped lang="scss">
.ifr {
    display: block;
    width: 92vw;
    height: 53.3333vw;
    margin: 0 auto;
}
.c999999 {
  color: #999999;
}
.wlinfo img {
  display: block;
  width: 4.8vw;
  height: 4.8vw;
  border-radius: 50%;
  background-color: #f6f6f6;
  margin-right: 1.0667vw;
}
.wlinfo p {
  font-size: 14px;
  color: #333333;
}
.wlinfo-btn-box {
  width: 100%;
  margin-top: 3.2vw;
  margin-bottom: 3.2vw;
  .wlinfo-btn {
    button {
      color: #333333;
      font-size: 14px;
      background-color: #f6f6f6;
    }
    span {
      width: 1px;
      height: 5.3333vw;
      background: #cccccc;
      opacity: 0.5;
      margin-left: 2.4vw;
      margin-right: 2.4vw;
    }
  }
}

.schedule-con__wlimg {
  display: block;
  width: 92vw;
  margin: 0 auto;
}
.schedule-con__tle {
  color: #333333;
  margin-top: 5.3333vw;
  padding-left: 15px;
}
.schedule-con__tle span {
  color: #999999;
}
.schedule-con-info {
  padding: 10px 15px 20px;
  align-items: flex-start;
}
.graybar {
  width: calc(100% - 30px);
  margin-left: 15px;
  border-bottom: 1px solid #cccccc;
  margin-bottom: 20px;
}
.step {
  padding-left: 30px;
}
.step__item {
  position: relative;
  margin-bottom: 20px;
}
.step__txt {
  color: #999999;
  font-size: 14px;
  padding-right: 15px;
}
.step__circle {
  position: absolute;
  width: 7px;
  height: 7px;
  background: #999999;
  top: 50%;
  left: -15px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.step__item::after {
  content: "";
  width: 1px;
  position: absolute;
  height: calc(100% + 16px);
  top: 14px;
  left: -16px;
  // transform: translateX(-50%);
  background-color: #999999;
}
.step__item:last-child::after {
  content: none;
}
// .step__circle::after {
//   content: "";
//   width: 1px;
//   position: absolute;
//   height: 86px;
//   top: -86px;
//   left: 50%;
//   transform: translateX(-50%);
//   background-color: #999999;
// }
.step__item.active .step__circle {
  width: 13px;
  height: 13px;
  background: #3f7c93;
}
.step__item.active .step__txt {
  color: #3f7c93;
}
.step__item .step__txt__desc {
  color: #999999;
  margin-top: 10px;
}
.step__item.active .step__txt__desc {
  color: #333333;
}
/* .step__item.active {
    margin-bottom: 30px;
} */
.step__item.active .step__circle::after {
  background-color: #3f7c93;
}
.step__item:first-child .step__circle::after {
  width: 0;
}
</style>